export class SessionStorage {
	static hasSessionStorage(): boolean {
		return typeof (window.sessionStorage) === "object";
	}
	static getFromStorage<T>(storageKey: string): T {
		if (SessionStorage.hasSessionStorage()) {
			return JSON.parse(window.sessionStorage.getItem(storageKey)) as T;
		}
		return null;
	}
	static pushToStorage(storageKey: string, data: any): void {
		if (SessionStorage.hasSessionStorage()) {
			let json = data;

			if (typeof data === "object") {
				json = JSON.stringify(data);
			}

			window.sessionStorage.setItem(storageKey, json);
		}
	}
	static removeFromStorage(storageKey: string) {
		if(SessionStorage.hasSessionStorage()) {
			window.sessionStorage.removeItem(storageKey);
		}
	}
}
